import React from 'react'
import renderHTML from 'react-render-html'
import './styles.scss'

export class Scenario extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      isMobile: window.innerWidth < 768
    }
  }

  render() {
    return (
      <div className='scenario ui container'>
        <div className='content'>
          <div className='header'>
            <h4>{this.props.title}</h4>
            <div className='meta'>
              <div className='caption left'>
                <img src={require('./images/uv.svg')} className='ui image' />
                {this.props.uv}
              </div>
              <div className='caption middle'>
                <img src={require('./images/temp.svg')} className='ui image' />
                {this.props.temp}°
              </div>
              <div className='caption right'>
                <img src={require('./images/humid.svg')} className='ui image' />
                {this.props.humid}%
              </div>
              <div className='criterions'>
                <div className='ui label'>
                  <div className='category'>
                    <div className='icon-wrapper'>
                      <img
                        src={require('./images/time.svg')}
                        className='ui fluid image'
                      />
                    </div>
                    Zerfallszeit
                  </div>
                  <div className='time'>
                    <span>≈&nbsp;&nbsp;{this.props.time}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Scenario
